<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 30721 30721"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="30721" height="30721" rx="2996" ry="2996" />
   <path class="fil1"
         d="M16793 14130c275,0 475,-15 728,-113 356,-137 638,-334 871,-645 75,-101 154,-216 206,-338 195,-456 249,-891 88,-1371 -156,-467 -426,-830 -712,-1211l-827 -1104c-110,-176 -142,-290 -285,-290 -116,0 -184,155 -262,284 -111,181 -589,810 -762,1021 -293,360 -636,868 -778,1292 -147,440 -118,833 37,1268 86,240 317,568 510,729 210,176 355,263 608,362 36,15 71,25 103,36 117,37 325,80 475,80z" />
   <g id="_801892128">
   <path class="fil1"
         d="M21421 27476l84 4c68,-8 29,9 117,-21l452 -278c598,-392 1131,-891 1568,-1401 1806,-2110 2456,-4837 2359,-7634 -15,-424 76,-704 -409,-531 -1437,513 -2792,1184 -3980,2067 -695,517 -600,421 -280,1286 396,1071 594,2281 605,3462 5,562 -56,1071 -159,1617 -59,309 -386,1301 -357,1429z" />
     <path class="fil1"
           d="M19396 27717c-3541,141 -5764,-135 -8681,-1924 -1586,-973 -2517,-1952 -3531,-3505 -484,-742 -818,-1417 -1159,-2307 -847,-2210 -836,-3655 -797,-6138 544,30 2237,573 2881,756 2546,726 5808,1576 7996,2859 2576,1511 4250,3115 4715,6153 85,553 195,2749 -119,3336 -897,-362 -1817,-970 -2603,-1421 -1433,-821 -3423,-2270 -4740,-3268l-2182 -1753c936,1958 4006,4440 5907,5674l2064 1317c247,168 82,-15 249,221z" />
  </g>
   <path class="fil1"
         d="M22421 14130c275,0 475,-15 729,-113 356,-137 637,-334 870,-645 76,-101 155,-216 207,-338 194,-456 248,-891 87,-1371 -156,-467 -426,-830 -711,-1211l-828 -1104c-109,-176 -142,-290 -285,-290 -115,0 -183,155 -261,284 -111,181 -590,810 -762,1021 -294,360 -637,868 -778,1292 -148,440 -119,833 37,1268 85,240 316,568 509,729 210,176 356,263 608,362 36,15 71,25 103,36 118,37 326,80 475,80z" />
   <path class="fil1"
         d="M19672 8295c275,0 475,-15 728,-113 356,-138 638,-335 871,-645 75,-101 154,-217 206,-339 195,-455 249,-890 88,-1371 -156,-467 -426,-830 -712,-1210l-827 -1105c-110,-175 -142,-289 -285,-289 -116,0 -184,155 -262,283 -111,182 -589,811 -762,1022 -293,360 -636,868 -778,1292 -147,440 -118,833 37,1268 86,240 317,567 510,729 210,176 355,262 608,362 36,14 71,25 103,36 117,37 325,80 475,80z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'Irrigation',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #83C354
}
</style>
